import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { useActions } from '../../../Actions';
import { useAccountId } from '../../../auth/useAccountId';

import { State } from '../../../reducer';
import { namespace } from '../../transactionDetails';
import { namespace as messagesNamespace } from '../../../messages';
import { hasVoidableState  } from '../../transactionHelpers';

import Page, { CustomBack, Title } from '../../../components/Page';
import Card from '../../../components/Card';
import VoidForm from './VoidForm';
import NotFound from '../../transactionDetails/components/NotFound';
import { LoadingOverlay } from '../../../components/Loading';
import VoidError from './VoidError';

const VoidTransaction = () => {
    const { t } = useTranslation();
    const accountId = useAccountId();
    const transactionId = useParams<{transactionId: string}>().transactionId;
    const { voidTransaction, setView, closeErrorModal } = useActions(namespace);
    const { transaction, isLoading, isNotFound, error } = useSelector<State, State[typeof namespace]>(
        (s) => s[namespace]
    );
    const { addMessage } = useActions(messagesNamespace);
    const showSuccessMessage = () => {
        addMessage({
            text: t('payments.voidTransaction.success.title'),
            severity: 'success',
        });
    };

    if (transaction && !hasVoidableState(transaction)) {
        return null;
    }

    return <Page
        title={<><CustomBack onClick={() => setView('details')} /><Title>{t('payments.voidTransaction.form.title')}</Title></>}
        hasEnvFrame={true}
    >
        <Card noPadding={isNotFound}>
            {transaction && <VoidForm
                transaction={transaction}
                voidTransaction={voidTransaction}
                accountId={accountId}
                isLoading={isLoading}
                showSuccessMessage={showSuccessMessage}
            />}
            {isLoading && <LoadingOverlay />}
            {isNotFound && <NotFound transactionId={transactionId} />}
        </Card>
        {error && <VoidError error={error} transaction={transaction} dismissModal={closeErrorModal} />}
    </Page>;
};

export default VoidTransaction;
